
<template>
  <div class="home">
    <div class="robotTotalArea">
      <div class="totalEchars">
        <div class="title">{{ $t('homes.robotTotal') }}<span>{{ robot_num }}</span></div>
        <echartsAnTotal v-if="echartsAnTotal_flag" :chartsData="stateList"></echartsAnTotal>
      </div>
      <div class="totalEchars">
        <div class="title">{{ $t('homes.tasksTotal') }}<span>{{ task_num }}</span></div>
        <echartsAnnular v-if="echartsAnnular_flag"  :chartsData="taskList"></echartsAnnular>
      </div>
      <div class="totalEchars responsive">
        <div class="title">{{ $t('homes.onlineTimeTotal') }}<span>{{ stat_total }}</span></div>
        <echartsLine v-if="echartsLine_flag" :dataY="echartsLineY" :dataX="echartsLineX"></echartsLine>
        <div class="foot">
          <div class="line"></div>
          <div class="describe">{{ $t('homes.nearly-7-days-onlineTime') }}</div>
        </div>
      </div>
      <div class="totalEchars ">
        <div class="title">{{ $t('homes.cumulativeMileage') }}<span>{{ total }}</span></div>
        <echartsLineRIce v-if="echartsLineRIce_flag" :dataY="echartsLineRIceY" :dataX="echartsLineRIceX"></echartsLineRIce>
        <div class="foot">
          <div class="line"></div>
          <div class="describe">{{ $t('homes.nearly-7-days-mileage') }}
          </div>
        </div>
      </div>
    </div>
    <div class="robotTimeArea">
      <div class="robotTimeArea-title">
        <div class="left"><span>{{ $t('homes.robotWorkingHoursData') }}</span>
          <el-popover :title="$t('homes.explain')" placement="top-start" :width="newpopover_width()" trigger="hover"
            :content="$t('homes.Statisticstasks')">
            <template #reference>
              <Warning class="warning" />
            </template>
          </el-popover>
        </div>
        <div class="right">
          <div v-for="(item, index) in daysArr" :key="index"
            :class="{ daysChange: true, activeAaysChange: index == defaultdays }" @click="dayChange(item, index)">
            {{ item.label }}</div>
          <div class="datePicker">
            <el-date-picker v-model="startEndTime" type="daterange" unlink-panels :disabled-date="expireTimeOption"
              :range-separator="$t('homes.to')" :start-placeholder="$t('homes.startTime')"
              :end-placeholder="$t('homes.endTime')" :shortcuts="shortcuts" size="small" @change="timeChange" />
          </div>
        </div>
      </div>
      <div class="robotTimeArea-content">
        <div class="echarts-1">
          <div class="title">
            <span>{{ $t('homes.trendWorkingHours') }}</span>
            <el-select v-model="workTimevalue" class="m-2" placeholder="Select" size="small" @change="workTimeChange">
              <el-option v-for="item in options" :key="item.building_id"
                :label="item.nick_name ? item.nick_name : item.sn" :value="item.sn" />
            </el-select>
          </div>
          <echartsWorkingTime v-if="echartsWorkingTime_flag" :dataY="echartsWorkingTimeY" :dataX="echartsWorkingTimeX" :max="workTimeMax">
          </echartsWorkingTime>
        </div>
        <div class="echarts-1">
          <div class="title">
            <span style="margin-left:135px;">{{ $t('homes.proportionWorkingHours') }}</span>
          </div>
          <echartsWorkTime v-if="echartsWorkTime_flag" :chartsData="worktimeRatioArr"></echartsWorkTime>
        </div>
      </div>
    </div>
    <div class="buildingArea robotTimeArea">
      <div class="robotTimeArea-title">
        <div class="left"><span>{{ $t('homes.buildingDeliveryTimes') }}</span>
          <el-popover :title="$t('homes.explain')" placement="top-start" :width="popover_width()" trigger="hover"
            :content="$t('homes.explainContent')">
            <template #reference>
              <Warning class="warning" />
            </template>
          </el-popover>
        </div>
        <div class="right">  
          <div v-for="(item, index) in daysArr" :key="index"
            :class="{ daysChange: true, activeAaysChange: index == defaultdayShadow }" @click="dayChangeTwo(item, index)">
            {{ item.label }}
          </div>
          <div class="datePicker">
            <el-date-picker v-model="startEndTimeShadow" type="daterange" unlink-panels :disabled-date="expireTimeOption"
              :range-separator="$t('homes.to')" :start-placeholder="$t('homes.startTime')"
              :end-placeholder="$t('homes.endTime')" :shortcuts="shortcuts" size="small" @change="timeChangeShadow" />
          </div>
        </div>
      </div>
      <div class="buildingArea-content">
        <div class="bar">
          <echartsBuildingBar v-if="echartsBuildingBarFlag" :dataX="echartsDeliveryX" :executingArr="executing"
            :CompletedArr="Completed" :nobodyArr="nobody" :abnormalArr="abnormal" :manualCancellationArr="manualCancellation">
          </echartsBuildingBar>
        </div>
        <div class="rankingList">
          <div class="rankingList-head">{{ $t('homes.buildingDeliveryList') }}</div>
          <div v-if="rankingListData">
            <div class="rankingList-center" v-for="(item, index) in rankingListData" :key="index">
              <div class="rankingList-center-left">
                <div v-if="index <= 2" class="blueRadius"><span>{{ index + 1 }}</span></div>
                <div v-else class="Radius blueRadius"><span>{{ index + 1 }}</span></div>
                <div>{{ item.destination }}</div>
              </div>
              <div class="rankingList-center-right">
                {{ item.StateTotal }}{{ $t('public.second') }}
              </div>
            </div>
          </div>
          <noData v-else :noDataHeight="200"></noData>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, watch, ref, nextTick, toRefs, unref, } from "vue";
import { roomInfo } from "@/apis/region";
import { getRobotList } from "@/apis/user";
import { getbuildingOrder } from "@/apis/robot"
import { useRouter, useRoute } from "vue-router";
import moment from "moment";
import { robotsSearch } from "@/apis/robot";
import echartsAnnular from './components/echartsAnnular/index.vue'
import echartsAnTotal from './components/echartsAnTotal/index.vue'
import echartsLine from './components/echartsLine/index.vue'
import echartsLineRIce from './components/echartsLineRIce/index.vue'
import echartsWorkingTime from './components/echartsWorkingTime/index.vue'
import echartsWorkTime from './components/echartsWorkTime/index.vue'
import echartsBuildingBar from './components/echartsBuildingBar/index.vue'
import { robotTotalStatus, taskNumber, robotsOnline, robotsOdometer, robotsWorktimeTrend, robotsworktimeRatio, buildingDelivery } from "@/apis/home";
import i18n from "@/locales/index";
import {
  momentStamp
} from "@/utils/robot";
const _t = i18n.global.t;
import noData from "@/components/noData/noData.vue"
import { getLanguage } from "@/utils/cookies";
export default defineComponent({
  components: {
    echartsAnnular,
    echartsAnTotal,
    echartsLine,
    echartsLineRIce,
    echartsWorkingTime,
    echartsWorkTime,
    echartsBuildingBar,
    noData
  },
  setup() {
    const state = reactive({
      echartsBuildingBarFlag: false,
      startEndTime: '',
      startEndTimeShadow: '',
      workTimevalue: '',
      shortcuts: '',
      echartsAnnular_flag: false,
      echartsAnTotal_flag: false,
      echartsLine_flag: false,
      echartsLineRIce_flag: false,
      echartsWorkingTime_flag: false,
      echartsWorkTime_flag: false,
      defaultdays: 0,
      defaultdayShadow: 0,
      daysArr: [
        {
          label: _t('public.lastSevenDays'),
          value: 7
        },
        {
          label: _t('public.lastFourteenDays'),
          value: 14
        },
        {
          label: _t('public.lastThirtyDays'),
          value: 30
        }
      ],
      options: [
      ] as any,
      robot_num: '',
      task_num: '',
      stat_total: '',
      total: '',
      rankingListData: [
      ] as any,
      taskList: [] as any,
      stateList: [] as any,
      echartsLineY: [] as any,
      echartsLineX: [] as any,
      echartsLineRIceY: [] as any,
      echartsLineRIceX: [] as any,
      echartsWorkingTimeY: [] as any,
      echartsWorkingTimeX: [] as any,
      worktimeRatioArr: [] as any,
      echartsDeliveryX: [] as any,
      executing: [] as any,
      Completed: [] as any,
      nobody: [] as any,
      abnormal: [] as any,
      manualCancellation: [] as any,
      workTimeMax: '' as any,
      workParams: {
        sn: '',
        day: 7,
        start_time: '',
        end_time: ''
      } as any,
      buildingParams: {
        sn: '',
        day: 7,
        start_time: '',
        end_time: ''
      } as any,
      popover_width(){
        let language = getLanguage()
        if(language == 'en'){
          return 320
        }else if(language == 'zh-cn'){
          return 260
        }else if(language == 'ko'){
          return 260
        }else if(language == 'de'){
          return 500
        }else if(language == 'fr'){
          return 400
        }else if(language == 'ja'){
          return 330 
        }else if(language == 'nl'){
          return 390
        }else if(language == 'pl'){
          return 360
        }
      },
      newpopover_width(){
        let language = getLanguage()
        if(language == 'en'){
          return 400
        }else if(language == 'zh-cn'){
          return 300
        }else if(language == 'ko'){
          return 300
        }else if(language == 'de'){
          return 400
        }else if(language == 'fr'){
          return 400
        }else if(language == 'ja'){
          return 410 
        }else if(language == 'nl'){
          return 450
        }else if(language == 'pl'){
          return 400
        }
      },
      expireTimeOption(date: any) {
        return date.getTime() > Date.now()
      },
      init() {
        // 机器人总数及状态查询
        robotTotalStatus().then((res: any) => {
          state.echartsAnTotal_flag = true
          state.robot_num = res.data.robot_num
          if (res.data.state_num.length > 5) {
            res.data.state_num.splice(5, 6)
          }
          if (res.data.robot_num > 0) {
            res.data.state_num.forEach((item: any) => {
              let taskObj = {} as any

              if (item.status == "inactivated") {
                item.name = _t('robotState.notActive') // 未激活
              }
              if (item.status == "offline") {
                item.name = _t('robotState.offline') // 离线
              }
              if (item.status == "charging") {
                item.name = _t('robotState.charge') // 充电
              }
              if (item.status == "busy") {
                item.name = _t('robotState.atWork') // 工作中
              }
              if (item.status == "idle") {
                item.name = _t('robotState.free') // 空闲
              }
              taskObj.value = item.num
              taskObj.name = item.name
              state.stateList.push(taskObj)
            });
          }

        })

        // 任务数量及状态查询
        taskNumber().then((res: any) => {
          state.task_num = res.data.task_num
          if (res.data.state_num) {
            res.data.state_num.forEach((item: any) => {
              if (item.state == "1") {
                item.name = _t('robotState.executing') // 进行中
              }
              if (item.state == "3") {
                item.name = _t('robotState.Completed') // 已完成
              }
              if (item.state == "4") {
                item.name = _t('robotState.nobodyTakesThings') // 无人取物
              }
              if (item.state == "5") {
                item.name = _t('robotState.abnormalEnd') // 异常结束
              }
              if (item.state == "6") {
                item.name = _t('disinfect.Manualcancellation') // 手动取消
              }
              item.value = item.num
            });
            state.taskList = res.data.state_num
          } else {
            state.taskList = []
          }
          state.echartsAnnular_flag = true
        })

        // 累计时长数量与每日趋势
        let params = {
          day: 7
        }
        robotsOnline(params).then((res: any) => {
          state.stat_total = Math.floor(res.data.stat_total / 60 / 60) + _t('home.hour') + Math.floor(res.data.stat_total / 60 % 60) + _t('home.min')
          if (res.data.stat_time) {
            res.data.stat_time.forEach((item: any) => {
              state.echartsLineY.push(item.stat_time)
              state.echartsLineX.push(item.date)
            });
          } else {
            state.echartsLineY = [0, 0, 0, 0, 0, 0, 0]
          }

          state.echartsLine_flag = true
        })

        // 累计里程
        robotsOdometer(params).then((res: any) => {
          state.total = res.data.total
          if (res.data.state_num) {
            res.data.state_num.forEach((item: any) => {
              state.echartsLineRIceY.push(item.odometer)
              state.echartsLineRIceX.push(item.date)
            });
          } else {
            state.echartsLineRIceY = [0, 0, 0, 0, 0, 0, 0]
          }
          state.echartsLineRIce_flag = true
        })
        // 机器人工作时长趋势
        state.robotsWorktimeTrend()
        // 机器人工作时长占比
        state.robotsworktimeRatio()

        // 楼宇配送次数对比
        state.buildingDelivery()

        let data:any = {
          search: '',
          pageSize: '',
          page: '',
          status: ['online','leave','unactive','offline'],
          limit: false
        }
        data.status = data.status.join()
        robotsSearch(data).then((res: any) => {
          let obj = {
            id: _t('home.Fullrobot'),
            nick_name: _t('home.Fullrobot'),
          }
          res.data.list.unshift(obj)
          state.options = res.data.list
          state.workTimevalue = state.options[0].id
        })
      },
      workTimeChange(val: number) {
        state.workParams.sn = val
        state.robotsWorktimeTrend()
      },
      dayChange(item: any, index: number) {

        if (state.defaultdays == index) {
          return
        }
        state.defaultdays = index
        state.startEndTime = ''
        state.workParams.day = item.value
        state.workParams.start_time = ''
        state.workParams.end_time = ''
        state.robotsWorktimeTrend()
        state.robotsworktimeRatio()
      },
      dayChangeTwo(item: any, index: number) {
        if (state.defaultdayShadow == index) {
          return
        }
        state.defaultdayShadow = index
        state.startEndTimeShadow = ''
        state.buildingParams.day = item.value
        state.buildingParams.start_time = ''
        state.buildingParams.end_time = ''
        state.buildingDelivery()
        state.getbuildingOrder()
      },
      timeChange() {
        console.log('执行',state.startEndTime)
        state.defaultdays = 10
        const time = state.startEndTime;
        // const room = state.roomData;
        if (time) {
          state.workParams.day = ''
          state.workParams.start_time = moment(time[0]).valueOf();
          state.workParams.end_time = moment(time[1]).valueOf() + (1000 * 24 * 60 * 60);
        }else {
          state.workParams.day = 7
          state.defaultdays = 0
        }
        state.robotsWorktimeTrend()
        state.robotsworktimeRatio()
      },
      timeChangeShadow() {
        state.defaultdayShadow = 10
        const time = state.startEndTimeShadow;
        if (time) {
          state.buildingParams.day = ''
          state.buildingParams.start_time = moment(time[0]).valueOf();
          state.buildingParams.end_time = moment(time[1]).valueOf() + (1000 * 24 * 60 * 60);
        }else{
          state.defaultdayShadow = 0
          state.buildingParams.day = 7
        }
        state.buildingDelivery()
        state.getbuildingOrder()
      },
      robotsworktimeRatio() {
        // 机器人工作时长占比
        robotsworktimeRatio(state.workParams).then((res: any) => {
          console.log('机器人工作时长占比', res)
          state.worktimeRatioArr = []
          if (res.data.stat_ratio) {
            res.data.stat_ratio.forEach((item: any) => {
              let worktimeRatio = {} as any
              worktimeRatio.value = item.stat_time
              if(item.robot_name){
                worktimeRatio.name = item.robot_name
              }else {
                worktimeRatio.name = item.robot_sn
              }
              state.worktimeRatioArr.push(worktimeRatio)
            });
          } else {
            state.worktimeRatioArr = []
          }
          state.echartsWorkTime_flag = true
        })
      },
      robotsWorktimeTrend() {
        // 机器人工作时长趋势
        robotsWorktimeTrend(state.workParams).then((res: any) => {
          state.echartsWorkingTimeY = []
          state.echartsWorkingTimeX = []
          if (res.data.stat_day) {
            let stat_time_arr = [] as any
            let robot_num_arr = [] as any
            res.data.stat_day.forEach((item: any) => {
              let setitme = moment(item.date).valueOf()
              item.date = moment(setitme).format(momentStamp('date'))
              stat_time_arr.push(item.stat_time)
              robot_num_arr.push(item.robot_num)
              state.echartsWorkingTimeX.push(item.date)
            });
            state.echartsWorkingTimeY.push(stat_time_arr)
            state.echartsWorkingTimeY.push(robot_num_arr)
          } else {
            state.echartsWorkingTimeY = [0, 0, 0, 0, 0, 0, 0]
          }
          state.echartsWorkingTime_flag = true
          state.workTimeMax = Math.max(...state.echartsWorkingTimeY[0])
        })
      },
      buildingDelivery() {
        state.echartsBuildingBarFlag = false

        // 楼宇配送次数对比
        buildingDelivery(state.buildingParams).then((res: any) => {
          state.echartsDeliveryX = []
          state.executing = []
          state.Completed = []
          state.nobody = []
          state.abnormal = []
          state.manualCancellation = []
          if (res.data.state_building_num.length > 0) {
            res.data.state_building_num.forEach((item: any, index: any) => {
              if(item.destination === '---'){
                 item.destination = '巡游'
              }
              state.echartsDeliveryX.push(item.destination)
              state.executing.push(0)
              state.Completed.push(0)
              state.nobody.push(0)
              state.abnormal.push(0)
              state.manualCancellation.push(0)
              item.list.forEach((el: any) => {
                if (el.state == '1') {
                  state.executing[index] += Number(el.num)
                }
                if (el.state == '3') {
                  state.Completed[index] += Number(el.num)
                }
                if (el.state == '4') {
                  state.nobody[index] += Number(el.num)
                }
                if (el.state == '5') {
                  state.abnormal[index] += Number(el.num)
                }
                if (el.state == '6') {
                  state.manualCancellation[index] += Number(el.num)
                }
              });
            })
          } else {
            state.echartsDeliveryX = [0, 0, 0, 0, 0, 0,0]
            state.executing = [0, 0, 0, 0, 0, 0]
            state.Completed = [0, 0, 0, 0, 0, 0]
            state.nobody = [0, 0, 0, 0, 0, 0]
            state.abnormal = [0, 0, 0, 0, 0, 0]
            state.manualCancellation = [0, 0, 0, 0, 0, 0]
          }
          state.echartsBuildingBarFlag = true
        })
      },
      // 楼宇配送次数排行榜
      getbuildingOrder() {

        getbuildingOrder(state.buildingParams).then((res: any) => {
          res.data.forEach((item:any) => {
            if(item.destination === '---'){
              item.destination = '巡游'
            }
          })
          state.rankingListData = res.data
        })
      },
    })

    onMounted(() => {
      state.getbuildingOrder()
      state.init()
    })
    return {
      ...toRefs(state)
    }
  }
});
</script>

<style lang="scss">
.home {
  .el-range-editor--small .el-range-input {
    cursor: pointer;
  }

  .el-range-editor--small .el-range-separator {
    min-width: 36px;
  }
}
</style>

<style lang="scss" scoped>
.home {
  margin: 24px;
  border-radius: 5px;
  min-height: 700px;
  position: relative;

  // 机器人总数区
  .robotTotalArea {
    display: flex;

    .totalEchars {
      position: relative;
      width: 24.1%;
      height: 260px;
      background: #FFFFFF;
      border-radius: 2px;
      margin-right: 1.2%;

      .title {
        margin-left: 20px;
        margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);

        span {
          font-size: 24px;
          color: #000000;
          font-weight: 500;
          margin-left: 10px;
        }
      }

      .foot {
        position: absolute;
        left: 38px;
        bottom: 33px;

        .line {
          width: 320px;
          height: 1px;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 1px;
        }

        .describe {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
        }
      }

    }

    .totalEchars:nth-child(4) {
      margin-right: 0px;
    }

    .responsive {

      position: relative;
    }
  }

  // 机器人时长区
  .robotTimeArea {
    height: 400px;
    background: #FFFFFF;
    border-radius: 2px;
    margin-top: 20px;
    padding: 0 20px;

    .robotTimeArea-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      .left {
        font-size: 14px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);

        .warning {
          cursor: pointer;
          position: relative;
          top: 4px;
          left: 10px;
          width: 18px;
          height: 18px;
        }
      }

      .right {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .daysChange {
          // width: 55px;
          padding: 0 15px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          background: #FFFFFF;
          border-radius: 0px 2px 2px 0px;
          border: 1px solid #D9D9D9;
        }

        .daysChange:nth-child(1) {
          border-right: 0px;
        }

        .daysChange:nth-child(2) {
          border-right: 0px;
        }

        .daysChange:nth-child(3) {
          margin-right: 40px;
        }

        .activeAaysChange {
          background: #1890FF;
          border-radius: 2px 0px 0px 2px;
          color: #FFFFFF;
        }
      }
    }

    .robotTimeArea-content {
      display: flex;

      .echarts-1 {
        width: 50%;

        .title {
          display: flex;
          align-items: center;
          height: 60px;

          span {
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
            margin-right: 20px;
          }
        }
      }
    }
  }

  // 楼宇区
  .buildingArea {
    height: 450px;
    background: #FFFFFF;
    border-radius: 2px;

    .buildingArea-content {
      display: flex;

      .bar {
        width: 60%;
      }

      .rankingList {
        margin: 50px 100px 0 100px;
        width: 260px;
        height: 300px;

        .rankingList-head {
          font-size: 14px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 40px;
          white-space: nowrap;
        }

        .rankingList-center {
          display: flex;
          margin-top: 20px;

          .rankingList-center-left {
            display: flex;
            align-items: center;
            width: 200px;

            .blueRadius {
              font-weight: 600;
              text-align: center;
              width: 24px;
              height: 24px;
              line-height: 24px;
              background: #45A0FF;
              border-radius: 50%;
              margin-right: 20px;

              span {
                color: #FFFFFF;
              }
            }

            .Radius {
              background: none;

              span {
                color: rgba(0, 0, 0, 0.85);
              }
            }

            div:nth-child(2) {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              width: 140px;
            }
          }

          .rankingList-center-right {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
    }
  }
}
</style>
